import { useState } from 'react';
import { SessionKindGroupName } from 'types/models/SessionsPageData';
import { t } from 'utilities/TranslationUtils';
import { AppButton } from 'components/form';
import { AppUseIcon } from 'components/ui';
import { kickNoun } from 'utilities/kickUtils';
import OnTargetTrend, { OnTargetTrendPoint } from './OnTargetTrend';
import { TrendGroupBy, TREND_GROUP_OPTIONS } from './playerPerformanceUtils';

interface PlayerPerformanceDisciplineCardProps {
  title: string;
  kind: SessionKindGroupName;
  sessionCount: number;
  kickCount: number;
  points: OnTargetTrendPoint[];
  onMoreDetails: () => void;
}

const PlayerPerformanceDisciplineCard: React.FunctionComponent<PlayerPerformanceDisciplineCardProps> = ({
  title,
  kind,
  sessionCount,
  kickCount,
  points,
  onMoreDetails,
}) => {
  const [trendGroupBy, setTrendGroupBy] = useState<TrendGroupBy>('sessions');

  return (
    <section className='pp-discipline-card' data-test='pp-discipline-card'>
      <div className='pp-discipline-card-head'>
        <h5>{title}</h5>
      </div>

      <div className='pp-discipline-card-stats'>
        <div className='pp-discipline-card-stat'>
          <span className='pp-discipline-card-stat-value'>{sessionCount}</span>
          <span className='pp-discipline-card-stat-label'>{t('playerPerformance.snapshotSessions')}</span>
        </div>
        <div className='pp-discipline-card-stat'>
          <span className='pp-discipline-card-stat-value'>{kickCount}</span>
          <span className='pp-discipline-card-stat-label'>{kickNoun(kind, true)}</span>
        </div>
      </div>

      <div className='pp-trend-picker pp-trend-picker--compact'>
        {TREND_GROUP_OPTIONS.map(({ key, labelKey }) => (
          <button
            key={key}
            type='button'
            className={`pp-trend-pill${trendGroupBy === key ? ' pp-trend-pill--active' : ''}`}
            onClick={() => setTrendGroupBy(key)}
          >
            {t(labelKey)}
          </button>
        ))}
      </div>

      <OnTargetTrend
        points={points}
        groupBy={trendGroupBy}
        kind={kind}
        hideTimelineControl={true}
      />

      <div className='pp-discipline-card-actions'>
        <AppButton variant='outline-primary' className='pp-more-details-btn' onClick={onMoreDetails}>
          {t('playerPerformance.moreDetails')}
          <AppUseIcon name='ChevronRight' className='ml-2' color='currentColor' style={{ width: '15px' }} />
        </AppButton>
      </div>
    </section>
  );
};

export default PlayerPerformanceDisciplineCard;